import { render, staticRenderFns } from "./ServiceCompany.vue?vue&type=template&id=196d141c&scoped=true"
import script from "./ServiceCompany.vue?vue&type=script&lang=js"
export * from "./ServiceCompany.vue?vue&type=script&lang=js"
import style0 from "./ServiceCompany.vue?vue&type=style&index=0&id=196d141c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196d141c",
  null
  
)

export default component.exports